<template>
	<div>
		<card class="ReServiceMultiOp">
			<h4>Внести изменения</h4>
			<div class="fields">
				<ReInputSearchDrop
					v-if="bShowAgent"
					class="col-sm-12 col-lg-4 d-inline-block mb-2"
					:findId="'agent_id'"
					:placeholder="'Выбрать ответственного'"
					v-model="agent_model"
					:objApiMethod="{'obj':'staff' ,'flt':{'fio':''}}"
					:strApiMethodKey="'fio'"
					@change="onAgentChange"
				/>
				<div class=" col-sm-12 col-lg-4 mb-2" style="align-items: center;" v-if="bShowStatus">
					<div class="d-flex">
						<el-select
							v-if="bShowStatus"
							class="w-100 select-primary "
							size="large"
							clearable
							placeholder="Выбрать статус"
							v-model="status_value"
						>
							<el-option
								v-for="(el_opt, el_index) in status_options"
								class="select-primary"
								:value="el_opt.value"
								:label="el_opt.label"
								:key="el_index"
							>
							</el-option>
						</el-select>
						<base-button v-if="bShowStatus" type="danger" class="no-border my-0" simple icon @click="status_value= '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
					</div>
				</div>
				<div class=" col-sm-12 col-lg-4" style="align-items: center;" v-if="bShowAddService">
					<div class="d-flex">
						<el-select
							v-if="bShowAddService"
							class="w-100 select-primary"
							size="large"
							clearable
							filterable
							placeholder="Добавить следующую услугу"
							v-model="service_value"
						>
							<el-option
								v-for="(el_opt, el_index) in service_options"
								class="select-primary"
								:value="el_opt.value"
								:label="el_opt.label"
								:key="el_index"
							>
							</el-option>
						</el-select>
						<base-button v-if="bShowAddService" type="danger" class="no-border my-0" simple icon @click="service_value= '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
					</div>
				</div>
				<button v-show="masTableSelection.length>0" class="btnChange btn btn-simple btn-success col-sm-12 col-lg-3 m-0" @click="StartChange()">Изменить</button>
			</div>
		</card>
		
		<card 
		v-loading.fullscreen.lock="$GVO.fullscreenLoading"
		element-loading-text="Загрузка данных..."
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)"	
		>
			<h4 class="mb-2">Услуг выбрано: <span class="ml-1" v-if="masTableSelection.length>0"> {{masTableSelection.length}}</span></h4>
			<el-table ref="multipleTable" :data="masServices" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
				<el-table-column
					type="selection"
					width="55">
				</el-table-column>
				<el-table-column
					min-width="80"
					sortable
					:sort-method="sortInt_id"
					label="ИД"
					property="id"
				></el-table-column>
				<el-table-column
					min-width="130"
					label="Услуга"
					property="BP_NAME"
				>
					<template v-slot="scope">
						{{scope.row.BP_NAME}} <span v-if="scope.row.BP_EXT_NAME">{{scope.row.BP_EXT_NAME}}</span> 
					</template>
			
				</el-table-column>
				<el-table-column
					min-width="130"
					label="ФИО клиента"
				>
					<template v-slot="scope">
						<router-link :to="'/data/clients/id/'+scope.row.client_id">{{scope.row.client_fio}}</router-link>
					</template>
				</el-table-column>
				<el-table-column
					min-width="150"
					label="Ответственный"
				>
					<template v-slot="scope">
						<router-link :to="'/data/staff/id/'+scope.row.agent_id">{{scope.row.agent_name}}</router-link>
					</template>
				</el-table-column>
				<el-table-column
					min-width="130"
					label="Статус"
					property="STATUS"
				></el-table-column>
				<el-table-column
					min-width="130"
					label="Этап"
					property="STAGE_NAME"
				></el-table-column>
				<el-table-column
					min-width="130"
					label="Источник"
					property="adsSourceName"
				></el-table-column>
				<el-table-column
					min-width="130"
					label="Причина отказа"
					property="nopurpose_text"
				></el-table-column>
			</el-table>
		</card>
		
	</div>
</template>

<script>
	import ReInputSearchDrop from "src/our_components/ReInputSearchDrop.vue";
	import { Select, Option, Table, TableColumn } from 'element-ui';

	export default {
		name: 'ReServiceMultiOp',
		components: {
			ReInputSearchDrop,
			[Option.name]: Option,
			[Select.name]: Select,
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
		},
		props: {
			masServices: Array,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				agent_model: {inputText: '',selectedVal: ''},
				status_value: '',
				status_options:[
					{value: 'to_work', label: 'В работу'},
					{value: 'to_archive', label: 'В отказ'},
				],
				service_value: '',
				service_options:[],
				masTableSelection: [],
				objGetParams:{},
				bShowAgent:true,
				bShowStatus:true,
				bShowAddService:true,
				fullscreenLoading: false,
			}
		},
		watch:{
			masServices(val){
				this.objGetParams = this.$GVO.GetAllGet();
				if(typeof this.objGetParams.service_status != 'undefined'){
					if(this.objGetParams.service_status=='srv_oncontrol'){
						this.bShowAgent=true;
						this.bShowStatus=true;
					}else if(this.objGetParams.service_status=='srv_new' || this.objGetParams.service_status=='srv_inwork'){
						this.bShowAgent=true;
						this.bShowStatus=false;
					}else{
						this.bShowAgent=false;
						this.bShowStatus=false;
					}
				}
			}
		},
		computed: {

		},
		methods: {
			onAgentChange(evt){
				
			},
			StartChange(){
				//console.log(this.masTableSelection);
				if(this.agent_model.selectedVal =='')this.agent_model.selectedVal = this.$GVO.unlinkObject(this.$GVO.my_profile.code);
				if(this.masTableSelection.length>0 && this.agent_model.selectedVal !=''){
					let masSend = [];
					for (let i = 0; i < this.masTableSelection.length; i++) {
						masSend.push(this.masTableSelection[i].id);
					}
					
					
					
					// if(this.bShowStatus && this.bShowAgent && this.bShowAddService){
					if((this.bShowAgent && this.service_value!='') || (this.bShowAddService && this.service_value!='')){
					// 1) this.bShowAddService всегда ТРУШНОЕ, поэтому сценарий обновить ответственного услуги никогда не выполняется 
					// 2) при этом this.bShowAgent=true; если на контроле, новая, в работе
						this.$GVO.ApiCall('SET_SERVICES_TO_FINAL',{obj:'services',flt:{ 'service_ids': masSend, 'final_type':this.status_value } ,uData:{'agent_id':this.agent_model.selectedVal,'next_bp_id':this.service_value} })
						.then((objApiStatus) => { 
							if(objApiStatus.success === true){ 
								//console.log(objApi);
								this.ProcessResult(objApiStatus,this.status_value!=''?this.status_value:false);
								this.service_value = '';
							}
						}).catch(errorObjApi => console.error(errorObjApi));
					}else{
						this.$GVO.ApiCall('UPD_SRV_CURATOR',{obj:'services',flt:{ 'service_ids': masSend } ,uData:{'agent_id':this.agent_model.selectedVal} })
						.then((objApi) => { 
							if(objApi.success === true){ 
								//console.log(objApi);
								this.ProcessResult(objApi);
								this.service_value = '';
							}
						}).catch(errorObjApi => console.error(errorObjApi));
					}

					// console.log(masSend);

				}
			},
			ProcessResult(objApi,status_value=false){
				let bSuccess = true;
				for (let i = 0; i < this.masServices.length; i++) {
					if(Object.keys(objApi.data).indexOf(this.masServices[i].id) != -1){
						if(objApi.data[this.masServices[i].id].success == true)this.masServices[i].agent_name = this.agent_model.inputText;
						if(status_value != false){
							for (let x = 0; x < this.status_options.length; x++) {
								if(this.status_options[x].value == status_value){
									this.masServices[i].STATUS = this.status_options[x].label;
								}								
							}
						}
						this.masServices[i] = {...this.masServices[i],...{'gop_success':objApi.data[this.masServices[i].id].success}};
						if(objApi.data[this.masServices[i].id].success == false) bSuccess = false;
					}
				}
				this.checkTableRows();
				this.$refs.multipleTable.doLayout();
				if(bSuccess){this.$emit("change", true);}
			},
			sortInt_id(a,b){
				return parseInt(a.id) - parseInt(b.id);
			},
			handleSelectionChange(val) {
				this.masTableSelection = val;
			},
			checkTableRows(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			tableRowClassName({row, rowIndex}) {
				if (typeof row.gop_success != 'undefined') {
					if(row.gop_success==false){
						return 'table-danger';
					} else if (row.gop_success==true) {
						return 'table-success';
					}
				}
				return '';
			},
			getServices(){
				this.service_options = [];
				this.$GVO.ApiCall('BP.GET',{flt:{ 'list': true,'only_act':1}})
					.then((objApiBP) => { 
						if(objApiBP.success === true){ 
							if(objApiBP.data.BP_DATA.length>0){
								for (let i = 0; i < objApiBP.data.BP_DATA.length; i++) {
									const objBP = objApiBP.data.BP_DATA[i];
									this.service_options.push({value: objBP.id, label: objBP.name});
								}
							}
						}
					}).catch(errorObjApi => console.error(errorObjApi));
			}
		},
		created(){
			this.objGetParams = this.$GVO.GetAllGet();
			if(typeof this.objGetParams.service_status != 'undefined'){
				if(this.objGetParams.service_status=='srv_oncontrol'){
					this.bShowAgent=true;
					this.bShowStatus=true;
				}else if(this.objGetParams.service_status=='srv_new' || this.objGetParams.service_status=='srv_inwork'){
					this.bShowAgent=true;
					this.bShowStatus=false;
				}else{
					this.bShowAgent=false;
					this.bShowStatus=false;
				}
			}
			this.getServices();
		}
	}
</script>
<style>
	.ReInputSearchDrop > .form-group{margin-bottom: 0px;}
	.ReInputSearchDrop {vertical-align: middle; height: 40px;}
	.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #01B0E0;
		border-color: #01B0E0;
	}
	.fields {display: flex; flex-wrap: wrap;}
</style>
